import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

export function useCompanyMembers() {
  const { company } = useRoleContext();

  const url = company != null ? `/companies/${company.id}/members` : null;

  const { data, loading, error } = useSwrFetch<CompanyMember[]>({
    url,
    errorMessage: "Failed to fetch company members",
  });

  return {
    members: data ?? [],
    error,
    loading,
  };
}
